import Button from '../../../../components/form/elements/button';
import Link from '../../../../components/form/elements/link';
import { WAREHOUSE_DEAL_VIEW } from '../../../../router/routes';
import { route } from '../../../../services/utils';
import { useState } from 'react';
import { useParams } from 'react-router';

export default function useEditFooter() {
  const { farmId, id, dealType } = useParams<{
    farmId: string;
    id: string;
    dealType: string;
  }>();

  const [footer] = useState(() => [
    Button('save'),
    Link(route(WAREHOUSE_DEAL_VIEW, { farmId, id, dealType }), 'cancel'),
  ]);

  return footer;
}
